import React from "react";
import Html from "./html";
import { Provider } from "./provider";

const Dashboard = () => {
    return(
        <Provider>
            <Html/>
        </Provider>
    );
}

export default Dashboard;